import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-orangnization",
  "use": "icon-orangnization-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-orangnization\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 640h-128V544a64 64 0 0 0-64-64H544V384H640a64 64 0 0 0 64-64v-256A64 64 0 0 0 640 0H384a64 64 0 0 0-64 64v256A64 64 0 0 0 384 384h96v96H256a64 64 0 0 0-64 64V640h-128A64 64 0 0 0 0 704v256a64 64 0 0 0 64 64h256a64 64 0 0 0 64-64v-256a64 64 0 0 0-64-64H256V544h512V640h-64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h256a64 64 0 0 0 64-64v-256a64 64 0 0 0-64-64zM384 320v-256h256v256z m-64 384v256h-256v-256z m640 256h-256v-256h256z\" p-id=\"7281\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/orangnization.svg
// module id = S5kW
// module chunks = 11